module.exports = __webpack_public_path__ + "img/pin-in-5.d421cffa.svg";